<div class="modal fade" [attr.id]="inputId + 'AssetSearch'">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header align-items-center">
                <h4 class="modal-header-title m-0">{{ 'Header.Assets' | translate }}</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-window-close red" aria-hidden="true"></i>
                </button>
            </div>
            <div class="modal-body" *ngIf="!!shownAssets" style="max-height:70vh; overflow-y:auto;">
                <input type="text" class="form-control" [(ngModel)]="searchString" (keyup)="filter()">
                <table aria-label="Searched asset table">
                    <thead>
                        <th>{{ 'Standard.Name' | translate }}</th>
                        <th>{{ 'Standard.Number' | translate }}</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let a of shownAssets" (click)="getAsset(a)" data-dismiss="modal">
                            <td>{{ a.modelName }}</td>
                            <td>{{ a.serialNumber }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
